import state from "./state.js";
import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

const happinessTipsModule = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {}
};

export const HAPPINESS_TIPS_MODULE = happinessTipsModule;
export default happinessTipsModule;
